import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../config";

export const register = (fullName, email, phone) => async (dispatch) => {
  // POST request using fetch()

  fetch(`${BASE_URL}/api/auth/signup`, {
    // Adding method type
    method: "POST",
    // Adding body or contents to send
    body: JSON.stringify({
      fullName: fullName,
      email: email,
      phone: phone,
      type: "cater",
    }),

    // Adding headers to the request
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    // Converting to JSON
    .then((response) => response.json())

    // Displaying results to console
    .then((json) => {
      console.log("RegisterCaterCheck", json);
      if (json.status === true) {
        Swal.fire("Success", json.message, "success", {
          confirmButtonColor: "#df0584",
          successButtonColor: "#df0584",
          buttonColor: "#df0584",
          buttons: false,
          timer: 2000,
        });
      } else {
        Swal.fire("Failed", json.message, "error");
      }

      const retrnObj = { type: "registerCater", payload: json };
      console.log("ObjectReturn", retrnObj);
      dispatch(retrnObj);
    });
};

export const loginAction = (phone) => async (dispatch) => {
  // POST request using fetch()

  fetch(`${BASE_URL}/api/auth/password/less/login`, {
    // Adding method type
    method: "POST",
    // Adding body or contents to send
    body: JSON.stringify({
      phone: phone,
    }),

    // Adding headers to the request
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    // Converting to JSON
    .then((response) => response.json())

    // Displaying results to console
    .then((json) => {
      console.log("LoginResponse", json.data.token);
      localStorage.setItem("Token", json.data.token);
      if (json.status === true) {
        Swal.fire("Success", json.message, "success", {
          confirmButtonColor: "#df0584",
          successButtonColor: "#df0584",
          buttonColor: "#df0584",
          buttons: false,
          timer: 2000,
        });
      } else {
        Swal.fire("Failed", json.message, "error");
      }

      const retrnObj = { type: "login", payload: json };
      console.log("ObjectReturn", retrnObj);
      dispatch(retrnObj);
    });
};

export const phoneCheckAction = (phone) => async (dispatch) => {
  // POST request using fetch()

  fetch(`${BASE_URL}/api/auth/phonecheck`, {
    // Adding method type
    method: "POST",
    // Adding body or contents to send
    body: JSON.stringify({
      phone: phone,
    }),

    // Adding headers to the request
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    // Converting to JSON
    .then((response) => response.json())

    // Displaying results to console
    .then((json) => {
      console.log("LoginResponseCheckPhone", json);
      localStorage.setItem("Token", json?.message);
      // if (json.status === true) {
      //   Swal.fire("Success", json.message, "success",
      //     {
      //       confirmButtonColor: "#df0584",
      //       successButtonColor: "#df0584",
      //       buttonColor: "#df0584",
      //       buttons: false,
      //       timer: 2000,
      //     }
      //   );
      // } else {
      //   Swal.fire("Failed", json.message, "error");
      // }

      // const retrnObj = { type: "phoneCheck", payload: json.data.token };
      const retrnObj = { type: "phoneCheck", payload: json };
      console.log("ObjectReturn", retrnObj);
      // dispatch({ type: "phoneCheck", payload: 'as' });
      dispatch(retrnObj);
    })
    .catch((err) => {
      // Swal.fire("Failed", err.response.message, "error");
    });
};
export const MainCourseAction = (courseCount) => async (dispatch) => {
  const returnObj = { type: "MainCourse", payload: courseCount };
  console.log(returnObj);
  // const returnObj = { type: "decMainCourse", payload: courseCount - 1 };
  dispatch(returnObj);
};
export const JuiceAction = (juice) => async (dispatch) => {
  const returnJuiceObj = { type: "juices", payload: juice };
  console.log(returnJuiceObj);
  dispatch(returnJuiceObj);
};

export const SlideAction = (slide) => async (dispatch) => {
  const returnObj = { type: "Slide", payload: slide };
  console.log(returnObj);
  dispatch(returnObj);
};

export const AllMealsAction = (mealArr) => async (dispatch) => {
  const returnObj = { type: "SelectedMeal", payload: mealArr };
  console.log(returnObj);
  dispatch(returnObj);
};
